export const JOURNEY_CONTENT = {
  heading: "Our Journey So Far",

  experience: {
    suffix: "+ Years of Experience",
    description: "India’s Largest recycler for e-waste and EV batteries",
  },

  cities: {
    suffix: "+ Cities",
    description: "Convenient doorstep pickup across India",
  },

  warehouse:{
    suffix:"+ Warehouses",
    description:"Strong logistics network enabling faster pickups"
  },

};